import React from "react";

export function AuroraBackground() {
  return (
    <>
      <div className="aurora-wrap">
        <div className="aurora-blob aurora-1" />
        <div className="aurora-blob aurora-2" />
        <div className="aurora-blob aurora-3" />
      </div>
      <div className="noise-overlay" />
    </>
  );
}
